<template>
  <SoPageWithHeader title="Test Accounts">
    <RpRunTimeline />
    <SoTabs v-model="tab" divider data-testid="test-accounts-tabs">
      <SoTab title="Finder">
        <div class="pt-4"><AdminTestAccountsTable /></div>
      </SoTab>
      <SoTab title="Cypress Health">
        <div class="pt-4"><TestAccountHealthTable /></div>
      </SoTab>
    </SoTabs>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import AdminTestAccountsTable from "@/views/admin/testAccounts/components/AdminTestAccountsTable.vue"
  import TestAccountHealthTable from "@/views/admin/testAccounts/components/health/TestAccountHealthTable.vue"
  import RpRunTimeline from "@/views/admin/testAccounts/components/health/RpRunTimeline.vue"
  import { defineComponent } from "vue"

  export default defineComponent({
    components: {
      AdminTestAccountsTable,
      TestAccountHealthTable,
      RpRunTimeline,
      SoPageWithHeader,
      SoTabs,
      SoTab,
    },
    data() {
      return {
        tab: 0,
      }
    },
  })
</script>
